module.exports = __webpack_public_path__ + "images/emoji/clock10.ff5e035d0f9be9110b9b.png";